import { render, staticRenderFns } from "./UserAccessDefinitionFormInput.vue?vue&type=template&id=13d164c2&scoped=true&"
import script from "./UserAccessDefinitionFormInput.vue?vue&type=script&lang=ts&"
export * from "./UserAccessDefinitionFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./UserAccessDefinitionFormInput.vue?vue&type=style&index=0&id=13d164c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d164c2",
  null
  
)

export default component.exports